/**
 * Labstep
 *
 * @module components/ShareLink/Accept/Entity/GroupOrOrganization/LimitReachedContent
 * @desc Component for when sharelink for entities limits of type group or user groups have been reached
 */

import AcademicActionUpgrade from 'labstep-web/components/Academic/Action/Upgrade';
import { ICONS } from 'labstep-web/constants/icons';
import { Button } from 'labstep-web/core/Button';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { useHasOrganization } from 'labstep-web/hooks/limits/limits';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IShareLinkAcceptEntityGroupOrOrganizationLimitReachedContentProps } from './types';

export const ShareLinkAcceptEntityGroupOrOrganizationLimitReached: React.FC<
  IShareLinkAcceptEntityGroupOrOrganizationLimitReachedContentProps
> = ({ onClick, heading, description, showUpgrade }) => {
  const hasOrganizations = useHasOrganization();

  return (
    <Flex column hAlignContent="center" className={styles.container}>
      <Image
        src="/img/empty-state/compliance.svg"
        data-public
        size="large"
      />
      <Header size="small" className={styles.heading}>
        {heading}
      </Header>
      <p className={styles.description}>{description}</p>
      <Flex hAlignContent="center" spacing="gap">
        <Button
          primary
          basic
          onClick={onClick}
          route={{ to: 'app_homepage' }}
          size="large"
          className={styles.button}
        >
          Go to your home workspace
        </Button>
        {showUpgrade && !hasOrganizations && (
          <AcademicActionUpgrade
            actionComponentProps={{
              type: 'button',
              icon: ICONS.upgrade.primary,
              text: 'Upgrade',
              showIcon: true,
              elementProps: {
                color: 'green',
                size: 'large',
                className: styles.shiny,
              },
              onClick: (): void => {},
            }}
          />
        )}
      </Flex>
    </Flex>
  );
};
